import { render, staticRenderFns } from "./MFA_Deactivation.vue?vue&type=template&id=39452702"
import script from "./MFA_Deactivation.vue?vue&type=script&lang=ts"
export * from "./MFA_Deactivation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports